<app-update-comment [responseMode]= true [id]=id> </app-update-comment>
  